import { formatDate, DATETIME_FORMATS } from '@myap/ui-library/esm/date'
import {
  STATUS_CANCELLED,
  DISPLAY_STATUS,
  APPROVAL_REQUEST_CONFIG,
  STATUS_STYLE_MAP,
  PROCESS_REQUEST_HAND_SHIPMENT_FIELD,
} from '../../../constants/ApprovalRequestConstants'
import { Error, Loader } from '../../common'
import { fetchAncillaryMaterialsApprovalRequestHistory } from '../../../actions/approvalRequestHistory'
import {
  selectSelectedApprovalRequest,
  selectApprovalRequestType,
} from '../../../selectors/approvalRequests'
import {
  getAncillaryMaterialRequestHistory,
  getAncillaryMaterialRequestHistoryStatusProps,
} from '../../../selectors/requestHistory'
import { sortColumnByKey } from '../../../utils/sort'

const mapStateToProps = (state, ownProps) => {
  const { panelIsOpen } = ownProps
  const selectedApprovalRequest = selectSelectedApprovalRequest(state)
  const arType = selectApprovalRequestType(state)
  const { fetching, error } = getAncillaryMaterialRequestHistoryStatusProps(state)
  const arId = selectedApprovalRequest[APPROVAL_REQUEST_CONFIG[arType].idField]
  const { specialOrderType, description } = selectedApprovalRequest
  return {
    approvalHistory: getAncillaryMaterialRequestHistory(state, arId),
    arId,
    specialOrderType,
    description,
    fetching,
    error,
    panelIsOpen,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ fetchAncillaryMaterialsApprovalRequestHistory }, dispatch)

const StatusMaterials = ({ items = [], quantity = null, description = null }) => {
  if (items.length > 0) {
    return sortColumnByKey(items, 'description', 'asc').map(item => (
      <div key={item.ancillaryCd}>
        {item.description}: {item.quantity}
      </div>
    ))
  } else if (description && quantity) {
    return (
      <div>
        {description}: {quantity}
      </div>
    )
  }
  return null
}

const StatusComments = ({ comments }) => {
  if (comments) {
    return <div style={{ fontStyle: 'italic' }}>{`"${comments}"`}</div>
  }
  return null
}

const ApprovalRequestHistoryRow = connect(mapStateToProps)(
  ({ status, key, first, description }) => {
    const { etsApprovalStatus, reviewedBy, comments, updateTimestamp } = status
    return (
      <tr key={key}>
        <td style={first ? { borderTopWidth: 0 } : {}}>
          <div style={STATUS_STYLE_MAP[etsApprovalStatus]}>{DISPLAY_STATUS[etsApprovalStatus]}</div>
          {status[PROCESS_REQUEST_HAND_SHIPMENT_FIELD] && (
            <div style={{ fontStyle: 'italic' }}>Handshipped</div>
          )}
          {status.etsApprovalStatus !== STATUS_CANCELLED ? (
            <>
              <StatusMaterials {...status} description={description} />
              {reviewedBy && <div>Processed By: {reviewedBy}</div>}
              <StatusComments comments={comments} />
            </>
          ) : null}
        </td>
        <td style={first ? { borderTopWidth: 0, whiteSpace: 'nowrap' } : { whiteSpace: 'nowrap' }}>
          {formatDate(updateTimestamp, 'MMMM d, yyyy')}
        </td>
      </tr>
    )
  }
)

const ApprovalRequestHistoryTable = connect(mapStateToProps)(({ approvalHistory = [] }) => {
  return (
    <table
      className="table"
      summary="Status of Ancillary Materials approval requests are listed by status date in descending order."
    >
      <caption className="sr-only">A view of Ancillary Materials approval request history</caption>
      <thead>
        <tr>
          <th scope="col">Status</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        {approvalHistory.map((row, index) => (
          <ApprovalRequestHistoryRow status={row} key={`${Math.random()}`} first={index === 0} />
        ))}
      </tbody>
    </table>
  )
})

class RequestHistory extends Component {
  componentDidMount() {
    const { arId, specialOrderType, fetchAncillaryMaterialsApprovalRequestHistory } = this.props

    fetchAncillaryMaterialsApprovalRequestHistory(arId, specialOrderType)
  }

  componentDidUpdate(prevProps) {
    const { arId, specialOrderType, panelIsOpen, fetchAncillaryMaterialsApprovalRequestHistory } =
      this.props

    if (panelIsOpen && prevProps.arId !== arId) {
      fetchAncillaryMaterialsApprovalRequestHistory(arId, specialOrderType)
    }
  }

  render() {
    const { approvalHistory = [], fetching, error } = this.props
    let output = null

    if (fetching) {
      output = <Loader />
    } else if (error) {
      output = <Error title="Error" message={error} />
    } else if (approvalHistory.length) {
      output = <ApprovalRequestHistoryTable />
    } else {
      output = <>No request history available</>
    }

    return (
      <div className="row" style={{ paddingBottom: '1.5em' }}>
        <div className="col-xs-12">{output}</div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestHistory)
